"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUniqueDeviceId = void 0;
/**
 * This function will create a unique device fingerprint base on the current user device
 * @returns string - Device Fingerprint
 */
const generateUniqueDeviceId = () => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === "undefined" ||
        !window.crypto ||
        !window.crypto.subtle ||
        !window.navigator ||
        !window.screen) {
        return "";
    }
    const { userAgent } = window.navigator;
    const { height, width, pixelDepth } = window.screen;
    let uid = userAgent.replace(/\D+/g, "");
    uid += height || "";
    uid += width || "";
    uid += pixelDepth || "";
    const uidUint8 = new TextEncoder().encode(uid); // encode as (utf-8) Uint8Array
    const hashBuffer = yield window.crypto.subtle.digest("SHA-256", uidUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashId = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join(""); // convert bytes to hex string
    return hashId;
});
exports.generateUniqueDeviceId = generateUniqueDeviceId;
//# sourceMappingURL=Analytics.helper.js.map